$(function(){

    if ($('#map-club').length) {
        let myMapSingle,
            myPlacemarkSingle,
            fullScreen = false,
            map = $('#map-club'),
            coordinates = JSON.parse(JSON.stringify(map.data('coordinates'))),
            icon = map.data('icon');
    
    
        ymaps.ready(init);
        function init() {
            myMapSingle = new ymaps.Map("map-club",
                {
                    center: [coordinates.lat, coordinates.lng],
                    zoom: 15,
                    yandexMapDisablePoiInteractivity: true,
                    suppressObsoleteBrowserNotifier:true,
                    suppressMapOpenBlock: true,
                    controls: []
                },
                {
                    searchControlProvider: 'yandex#search'
                })
    
                myPlacemarkSingle = new ymaps.Placemark(myMapSingle.getCenter(), {
                    hintContent: '',
                    balloonContent: ''
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: icon,
                    iconImageSize: [36, 41],
                    iconImageOffset: [-18 , -20]
                })
    
                const zoomControl = new ymaps.control.ZoomControl({
                    options: {
                        size: "large",
                        position: {
                            bottom: 40,
                            right: 20,
                        }
                    }
                });
            myMapSingle.geoObjects
                .add(myPlacemarkSingle);
    
            myMapSingle.panes.get('ground').getElement().style.filter = 'grayscale(100%) invert(100%)';
            myMapSingle.controls.add(zoomControl);
            myMapSingle.behaviors.disable('scrollZoom');
    
        }
    }
    
    
    //main map
        let containerMap = $(".container-map");
        const map = $('#map');
        const icon = map.data('icon');
        const mapZoom = 10;
        const urlJson = map.data('url');
    
        if(!map.length) return
    
        ymaps.ready(() => {
    
            const myMap = new ymaps.Map("map", {
                center: [55.706242, 37.639811],
                zoom: mapZoom,
                yandexMapDisablePoiInteractivity: true,
                suppressObsoleteBrowserNotifier:true,
                suppressMapOpenBlock: true,
                controls: []
            });
    
            const zoomControl = new ymaps.control.ZoomControl({
                options: {
                    size: "large",
                    position: {
                        bottom: 40,
                        right: 20,
                    }
                }
            });
            myMap.controls.add(zoomControl);
            myMap.behaviors.disable('scrollZoom');
    
            const objectManager = new ymaps.ObjectManager({
                geoObjectOpenBalloonOnClick: false
            });
    
            objectManager.objects.options.set({
                iconLayout: 'default#image',
                iconImageHref: icon,
                iconImageSize: [36, 41],
                iconImageOffset: [-18 , -20]
            });
    
            myMap.geoObjects.add(objectManager);
    
            myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%) invert(100%)';
    
    
            function setMapCenterByObjectId(id) {
                const object = objectManager.objects.getById(id);
                const objectCoord = object.geometry.coordinates;
            console.log(objectCoord)
                const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            
                const offsetY = (screenWidth >= 1280) ? 0.006 : 0;
                const offsetX = (screenWidth >= 1280) ? -0.001 : 0;
            
                const newCoord = [
                    objectCoord[0] - offsetY,
                    objectCoord[1] - offsetX,
                ];
            
                myMap.setCenter(newCoord, 14);
            }
    
            $.ajax({
                url: urlJson
            }).done(function(data) {
    
                objectManager.add(data);
                
                let $regionItem = $('.js-region'),
                    $mapPin = $('.js-map-pin')
    
                $regionItem.on('click', function(){ 
                    let $this = $(this),
                        regionNumber = $(this).data('region'),
                        name = $(this).data('region-text') ? $(this).data('region-text') : $(this).text();
    
                    objectManager.setFilter(function (object) {
                        return object.properties.region == regionNumber;
                    });
    
                    myMap.setBounds(myMap.geoObjects.getBounds(), {
                        checkZoomRange: true,
                        zoomMargin: 50
                    });
    
                    $regionItem.removeClass('active');
                    $this.addClass('active');
                    $selectMapText.text(name);
                    $countries.hide();
                    $mapPin.hide();
                    $(`.js-map-pin[data-region=${regionNumber}]`).show();
                });
    
                setTimeout(function(){
                    $('.js-region-list .js-region:first-child').trigger('click');
                    $('.js-countries .js-country:first-child').trigger('click');
                    $('#map').addClass('active');
                },1000)
    
                $mapPin.on('click', function(e){
                    let $this = $(this),
                        activePin =$this.attr('id')
    
                    setMapCenterByObjectId(activePin);
    
                    $mapPin.removeClass('active');
                    $this.addClass('active');
    
                    let target = $this.attr('data-link');
                    let href = $this.attr('data-href');
                    let modal = $this.attr( 'data-open' );
    
                    openPopup(target, href, modal);
                    
                })
    
                objectManager.objects.overlays.events.add('click', function (e) {
                    objectManager.objects.setObjectOptions(
                        e.get('objectId')
                    );
    
                    
    
                    let activePoint = e.get('objectId');
                    let activePinBlock = $(`.js-map-pin[id=${activePoint}]`);
    
                    activePinBlock.trigger('click');
    
                    $('.map__list').animate({
                        scrollTop: activePinBlock.offset().top
                    }, 500);
                });
    
            });
        });
    
    //country-region
        let $country = $('.js-country');
    
        $country.on('click', function(){
            let $this = $(this),
                activeCountry = $this.data('country')
    
            $('.container-map .js-region').hide();
            $(`.js-region[data-country=${activeCountry}]`).show();
            $country.removeClass('active');
            $this.addClass('active');
        })
    
        let $countries = $('.js-countries'),
            $selectMap = $('.js-map-select'),
            $selectMapText = $('.js-map-select-text');
    
        $selectMap.on('click', function(){
            $countries.show();
        })
    
    })
    
    //map mask 
        $('.map__dis').on('click', function() {
            $(this).hide();
        })
    
    $('.map__select, .js-close-modal-map').on('click', function(){
        $('.js-map-modal').removeClass('is-show');
    })